import React from "react";
import Card from "./Card";
import data from "../../../Data/Portfolio_data";
import Fade from "react-reveal/Fade";

const PortfolioAll = ({ css }) => {
  return (
    <Fade bottom>
      {" "}
      <div className="mb-20">
        <h3 className="text-center  text-[#1F0D2B] text-[38px] font-fira font-bold ">
          Our Recent Webflow Projects
        </h3>
        <p className="text-[#838383] px-2 max-sm:px-0 mb-10 text-sm max-sm:text-lg text-center mt-[10px] uppercase">
          We provide many free customizable webflow templates for the beginner
        </p>
        <section className="max-w-[1323px] px-5 max-sm:px-10 max-lg:px-20  2xl:px-5 mx-auto mt-10 max-sm:grid grid-cols-2 max-lg:grid-cols-3 justify-center items-center gap-10 ">
          {data.map((data, index) => (
            <Card key={index} css={css} data={data} />
          ))}
        </section>
      </div>
    </Fade>
  );
};

export default PortfolioAll;
